module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_vm._v("\n  Test\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3665275e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/card/test.vue
// module id = 755
// module chunks = 15